/**
 * CSS animation timing constants exported for use in JavaScript/TypeScript.
 * These values must be kept in sync with their corresponding SCSS files.
 */

// From palette.scss and overlays.scss - used for window animations
export const windowEnterTimeout = 200; // 0.2s
export const windowExitTimeout = 400; // 0.4s

// From input.scss - used for input feedback animations
export const feedbackEnterTimeout = 200; // 0.2s
export const feedbackExitTimeout = 400; // 0.4s

// From playerFrameset.scss - used for frame animations
export const frameEnterTimeout = 200; // 0.2s (uses $enter-timeout)
export const frameExitTimeout = 400; // 0.4s (uses $exit-timeout)

// From media.scss - used for media animations
export const mediaEnterTimeout = 300; // 0.3s
export const mediaExitTimeout = 300; // 0.3s

// From momentCloud.scss - font sizes
export const topicMinFontSize = 16; // 16px
export const topicMaxFontSize = 36; // 36px

// Export objects matching the SCSS :export blocks
export const paletteVariables = {
  windowEnterTimeout,
  windowExitTimeout,
};

export const overlaysVariables = {
  windowEnterTimeout,
  windowExitTimeout,
};

export const inputVariables = {
  feedbackEnterTimeout,
  feedbackExitTimeout,
};

export const playerFramesetVariables = {
  frameEnterTimeout,
  frameExitTimeout,
};

export const menuVariables = {
  windowEnterTimeout,
  windowExitTimeout,
};

export const mediaVariables = {
  windowEnterTimeout: mediaEnterTimeout,
  windowExitTimeout: mediaExitTimeout,
};

export const momentCloudVariables = {
  topicMinFontSize,
  topicMaxFontSize,
};
